import { Component } from "@angular/core";

@Component({
	selector: "bp-content",
	templateUrl: "./bp-content.component.html",
	standalone: false
})
export class BpContentComponent {}
